import { ICategorieMenu } from "../../models/component/carteExplain/categories";
import { IDataCarte } from "../../models/component/carteExplain/datacarte";
import { IDataCartePost } from "../../models/component/carteExplain/datacartePost";
import { IDataCartes } from "../../models/component/carteExplain/datacartes";
import http from "../http-common";


const getAllMenu = () => {
  return http.get<IDataCartes[]>("/menu");
}
const getAllCategorie= () => {
  return http.get<ICategorieMenu[]>("/menu/categories");
}
const post = (id: number, data: IDataCartePost, token: string) => {
  return http.post<any>(`/menu/categories/${id}`, data, { headers: { Authorization: "Bearer " + token } });
};
const update = (id: number, data: IDataCarte, token: string) => {
  return http.put<any>(`/menu/categories/${id}`, data, { headers: { Authorization: "Bearer " + token } });
};

const removeByCategoriesId = (id: number,token:string) => {
  return http.delete<any>(`/menu/categories/${id}/all`, { headers: { Authorization: "Bearer " + token } });
};

const removeByProductId = (id: number,token:string) => {
  return http.delete<any>(`/menu/categories/${id}`, { headers: { Authorization: "Bearer " + token } });
};

const MenuService  = {
  getAllMenu,
  getAllCategorie,
  post,
  update,
  removeByCategoriesId,
  removeByProductId
};
  
export default MenuService;